/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_TeamsInputs */

const en_entity_teams = /** @type {(inputs: Entity_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const de_entity_teams = /** @type {(inputs: Entity_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {Entity_TeamsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_teams = /** @type {((inputs?: Entity_TeamsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_TeamsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teams(inputs)
	return de_entity_teams(inputs)
});